(function() {
    'use strict';

    var ID = 'js-expandable-text-box',
        elements = [];

    // FIXME: remove section below once we only output logs in dev env
    var log = function(message) {
        // console.log( message )
    }

    /*
     *      ExpandableTextBox Class
     */
    var ExpandableTextBox = function($button) {
        this.$html = $button.addClass('initialized');
        return this.init();
    };

    ExpandableTextBox.prototype = {
        $html: {},
        $parent: {},
        $otherParagraphs: {},
        $buttons: {},
        isExpanded: false,
        textHeight: 0,

        init: function() {
            log(ID + '::init');
            this.$parent = this.$html.parent();
            this.$otherParagraphs = this.$html.find('.other-paragraphs');
            this.$buttons = this.$html.find('a.read-more, a.read-less');
            this.isExpanded = false;
            this.textHeight = 0;

            this.refreshTextHeight();
            this.initEventHandlers();
            return this;
        },

        initEventHandlers: function() {
            this.$buttons.on('click', $.proxy(this.onButtonClicked, this));
        },

        refreshTextHeight: function() {
            this.$otherParagraphs.css({
                maxHeight: 'none'
            });
            this.textHeight = this.$otherParagraphs.height();
            this.$otherParagraphs.css({
                maxHeight: 0
            });
        },

        onButtonClicked: function(e) {
            log(ID + '::onButtonClicked', e);

            var $button = $(e.target),
                isReadMore = $button.hasClass('read-more'),
                scrollTo = $button.attr('data-scroll-to');

            if (scrollTo) {
                // FIXME: Replace $bdoy with cached selectors one day
                var $body = $('html, body'),
                    $scrollTo = scrollTo == 'main' ? this.$html.closest('main') : this.$html.find(scrollTo),
                    newScroll = $scrollTo.offset().top;

                // FIXME: Get height from cached selectors once available one day
                newScroll -= $('header#head').outerHeight();
                newScroll -= $('nav.sub_nav').outerHeight();
                newScroll -= $(window).height() * 0.1;

                // FIXME: Replace with GSAP once included
                $body.stop(true, true).delay(isReadMore ? 500 : 0).animate({
                    scrollTop: newScroll
                }, 'slow');
            }

            if (isReadMore == this.isExpanded) {
                return;
            }

            this.isExpanded = !this.isExpanded;
            this.$html.toggleClass('is-expanded', this.isExpanded)
            this.$otherParagraphs.css({
                maxHeight: this.isExpanded ? this.textHeight : 0
            });
        }
    };

    /*
     *      Overall creator and eventhandler
     */
    var init = function() {
            log(ID + ' :: loaded');
            findExpandableTextBoxs();
            initEventHandlers();
        },

        findExpandableTextBoxs = function($parent) {
            var selector = '.' + ID + ':not( .initialized )',
                $domItems = $parent == null ? $(selector) : $parent.find(selector),
                len = $domItems.length;

            while (len--) {
                elements.push(new ExpandableTextBox($domItems.eq(len)));
            }
        },

        initEventHandlers = function() {
            // FIXME: Implement EventHandler once working on the refresh logic
            // EventHandler.bind( 'refresh', findExpandableTextBoxs );
        };

    $(init);
})();
